<div
    class="search-panel w-100 h-100 flex justify-content-space-between align-content-center position-relative"
    [ngStyle]="{ width: width }"
    [class.global]="mode === 'global'"
    [class.component-border]="mode === 'component-border'"
    [class.rounded]="rounded"
>
    <div class="w-100 h-100 justify-content-space-between flex align-items-center position-relative" [ngClass]="getMode()">
        <div class="flex align-items-center w-100 h-100">
            <uvx-icon-button (click)="onSearch()" icon="search"></uvx-icon-button>
            <ng-content></ng-content>
        </div>

        <uvx-icon-button
            *ngIf="mode === 'global' || 'component-border'"
            matTooltip="Clear search query"
            (click)="onSearchClearClicked($event)"
            icon="close"
        >
        </uvx-icon-button>
    </div>

    <div
        *ngIf="showSuggestions"
        [ngStyle]="{ 'max-height': suggestionsDropdownHeight }"
        class="suggestions-dropdown flex flex-column"
    >
        <ng-content select="[suggestions]"></ng-content>
    </div>
</div>
